<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroTrinpodServer" />
    <!--SectionTrinpod /-->
    <Section :content="trinpodSpaceTime" />
    <Section :content="crosslink" />
    <SectionSearchAPI />
    <Section :content="versioning" videoHeightOverride="true" />
    <SectionWhatIsSolid />
    <SectionSecureSharing />
    <SectionBigData />
    <CallToAction :content="buildingCTA" />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionTrinpod from '@/components/section-trinpod.vue';
import SectionSearchAPI from '@/components/section-search-api.vue';
import SectionWhatIsSolid from '@/components/section-what-is-solid.vue';
import SectionSecureSharing from '@/components/section-secure-sharing.vue';
import SectionBigData from '@/components/section-big-data.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
export default {
  name: 'TrinPodServer',
  components: {
    MainNavBar,
    Hero,
    Section,
    SectionTrinpod,
    SectionSearchAPI,
    SectionWhatIsSolid,
    SectionSecureSharing,
    SectionBigData,
    CallToAction,
    GmxFooter
  },
  data() {
    return { 
      heroTrinpodServer: { 
        eyebrowIcon: 'trinity_secure.png',
        eyebrowTitle: 'The Building Knowledge Accelerator',
        eyebrowSubtitle: '',
        header: 'TrinPod\u2122 Server',
        subheader: 'TrinPod\u2122 Server provides the world\'s first conceptually indexed space-time systems digital twin. It also provides Crosslink, which reads documents for you and links them to your systems with a powerful Search API. TrinPod\u2122 Server runs in the cloud or on premise, and enables you to own and control your data and collaborate globally with the highly secure W3C Solid API.',
        //subheader: 'TrinPod\u2122 Servers use the W3C Solid API to ensure the highest security for detailed user access and machine to machine data communication while giving users 100% ownership and control over their data.',
        img: 'trinpod-server-globe.png',
        videoId: '',
        buttons: [
          { label: 'TrinPod\u2122', path: '', id: 'trinpod-space-time' },
          { label: 'Crosslink', path: '', id: 'crosslink' },
          { label: 'Search API', path: '', id: 'search-api' },
          { label: 'Versioning', path: '', id: 'versioning' },
          { label: 'Solid W3C API', path: '', id: 'what-is-solid' },
          { label: 'Secure Data Sharing', path: '', id: 'secure-sharing' },
          { label: 'Big Data', path: '', id: 'big-data' },
        ]
      },
      trinpodSpaceTime: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'TrinPod\u2122',
        headlineIcon: 'trinity_secure.png',
        paragraphs: [
          'The world\'s first conceptually indexed space-time digital twin using Solid.',
          'A TrinPod\u2122 models the complete space-time of part of the world linking systems to documents about those systems. When information is requested by an app, a human-based data structure is read into the server\'s conceptual awareness with real-time inference.'
        ],
        id: 'trinpod-space-time',
        image: '',
        videoId: '892755542',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        //learnMoreLink: '/trinpod',
      },
      crosslink: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Crosslink',
        headlineIcon: 'trinapp_crosslink.png',
        paragraphs: [
          'Crosslink uses a human reading approach to transform any PDF file into an intelligentPDF\u2122 - a hierarchy of data objects from document > section > page > unit of thought > word.  Drawings and Specifications are parsed for building related information with a review to confirm results and system tags discovered.  Links are written to all intelligentPDF\u2122 files for page and system object navigation.'
        ],
        id: 'crosslink',
        image: 'crosslink-image.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
      },
      versioning: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Versioning',
        paragraphs: [
          'All systems, system objects, files, document sections, pages, units of thought on pages, attributes, states, events and processes have their own source-of-truth url that does not change as those objects change through time. Because of this, a simple click from a QR code on a mobile device delivers the user directly to the latest version of that object, whether a system or page in a document, with the full history of change available on request.'
        ],
        id: 'versioning',
        image: '',
        videoId: '897892263',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
      },
      buildingCTA: {
        header: 'Start using TrinPod\u2122',
        bgClass: 'bg-neon-blue-grad',
        btnText: "Get started - it's free",
        btnVariant: 'turquoise'
      }
    }
  }
};
</script>
